import { useLazyQuery } from '@apollo/react-hooks';
import { GET_PROVIDER_MEMBER } from 'api/graphql/v2/queries/Providers';
import React, { useEffect } from 'react';
import Content from 'views/components/ui/content';
import Breadcrumbs from 'views/components/ui/profile/Breadcrumbs';
import { formatAttendeeName } from 'utils/format';
import ProviderSidebar from 'pages/provider/profile/sidebar';
import { ProfileLayout } from 'pages/provider/profile/layout.style';
import Header from 'pages/provider/profile/header';
import StaffTabs from './tabs';

const ProviderProfile = ({ match }) => {
  const id = match.params.id;
  const [ProviderData, setProviderData] = React.useState();
  const [GetSelectedProviderData, { loading, error }] = useLazyQuery(
    GET_PROVIDER_MEMBER,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        id: Number(id)
      },
      onCompleted: data => {
        setProviderData(data);
      }
    }
  );

  useEffect(() => {
    GetSelectedProviderData();
  }, [GetSelectedProviderData]);

  return (
    <Content loading={loading} error={error} data={ProviderData}>
      {() => {
        const provider = ProviderData.provider;
        // New (Figma) template only for DT speciality; others keep old template.
        const isDtTemplate = provider?.speciality?.department === 'DT';

        return isDtTemplate ? (
          <ProfileLayout>
            <ProviderSidebar provider={provider} />
            <div className="profile-main">
              <Breadcrumbs
                userType="providers"
                user={provider}
                label={formatAttendeeName(
                  provider?.firstName,
                  provider?.lastName,
                  provider?.clinic?.abbreviation,
                  provider?.speciality?.abbreviation,
                  provider?.displayName
                )}
              />
              <StaffTabs provider={provider} newDesign />
            </div>
          </ProfileLayout>
        ) : (
          <>
            <Breadcrumbs userType="providers" user={provider} />
            <Header provider={provider} />
            <StaffTabs provider={provider} />
          </>
        );
      }}
    </Content>
  );
};
export default ProviderProfile;
